import React, { useMemo } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import RowName from "../RowName";
import TableCell from "../TableCell";
import { CalculationStatusSource, ResultElementSourceAppearance, SimulationRunState, } from "store/rs-workspace/rs-workspace.types";
import { getCalculationTableResultSelector } from "store/rs-workspace/selectors/results.selectors";
import { isTableSourceCompletedSelector, tableColumnsBindingSelector, } from "store/rs-workspace/selectors/completeness.selectors";
import * as styles from "../Table/styles.module.scss";
const TableRow = ({ row, rows, resultSetId, elementId, columns, editMode = false, index, setShowCopiedToClipboardMessage, deleteRow, moveRows, upsert, }) => {
    const isRowCompleted = useSelector(isTableSourceCompletedSelector(row ?? {}));
    const columnsBindingMap = useSelector(tableColumnsBindingSelector(rows, columns));
    const { resultRows, calculationRows } = useSelector(getCalculationTableResultSelector({ resultSetId, resultSetElementId: elementId }));
    const rowResult = useMemo(() => (row.changed ? undefined : resultRows?.find(({ rowId }) => rowId === row.id)), [resultRows, row.changed, row.id]);
    const appearance = useMemo(() => {
        const { status } = (calculationRows?.find(({ responseId }) => row.id === responseId) ||
            {});
        if (!isRowCompleted) {
            return ResultElementSourceAppearance.Incomplete;
        }
        if (status === CalculationStatusSource.InProgress || rowResult?.fetching) {
            return ResultElementSourceAppearance.InProgress;
        }
        if (status === CalculationStatusSource.Paused) {
            return ResultElementSourceAppearance.Paused;
        }
        if (rowResult?.state === SimulationRunState.ERROR) {
            return ResultElementSourceAppearance.Error;
        }
        if (rowResult?.columns?.length) {
            return ResultElementSourceAppearance.Calculated;
        }
        return ResultElementSourceAppearance.Ready;
    }, [calculationRows, isRowCompleted, row.id, rowResult]);
    return (React.createElement("tr", { key: index },
        React.createElement("td", { className: classNames(styles["row-item"], styles["row-item-firstColumn"]) },
            React.createElement(RowName, { editable: editMode, row: row, rows: rows, deleteRow: deleteRow, moveRows: moveRows, upsert: upsert, appearance: appearance, accuracy: rowResult?.accuracy ?? null, elementId: elementId })),
        columns.map((column, index) => {
            const { bound, customVariable } = columnsBindingMap.find(({ id }) => id === column.id) || {};
            return (React.createElement("td", { key: `${row.id}-${column.id}`, className: styles["row-item"] },
                React.createElement(TableCell, { column: column, row: row, index: index, setShowCopiedToClipboardMessage: setShowCopiedToClipboardMessage, rowResult: rowResult, rowCalculationIsInProgress: appearance === ResultElementSourceAppearance.InProgress, impossibleMessage: !bound
                        ? `This ${customVariable ? "Custom  Variable" : "Parameter"} can not be calculated for the selected source.`
                        : undefined })));
        })));
};
export default TableRow;
